export default __webpack_public_path__ + "static/Card34-86d778ef420d92535a2c87026f7974df.png";